export default __webpack_public_path__ + "static/media/mobile_supervision.a593567f.svg";